import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'produto-search-banner',
  templateUrl: './produto-search-banner.component.html',
  styleUrls: ['./produto-search-banner.component.scss']
})
export class ProdutoSearchBannerComponent implements OnInit{

  public dataItem:any      = null;
  public configuracao:any  = null;
  public destinos:any      = null;
  public comboDestinos:any = [];
  public loader:any        = false;
  public produtos:any      = [];

  constructor(
    public api: ApiService,
    public app: AppService,
    public data: DataService
  ){

    this.configuracao = this.data.getConfiguracao();
    this.destinos     = this.data.getDestinos();

  }
  /**
   * 
   * Get data
   * 
   */
  getData(){

    try{

      this.loader = true;

      this.api.produto().search({
        nome: this.dataItem.nome,
        produto_cidade_id: this.dataItem.produto_cidade_id
      }).subscribe((response:any) => {

        this.loader = false;

        if(response.status == 1){

          if(response.data.produtos.length > 0){

            this.produtos = response.data.produtos;

          }else{

            this.app.info("Não foram encontrados produtos para a sua pesquisa.");

          }

        }else{

          let error   = this.api.formatError(response);
          this.app.info("Houve um erro. Tente nvamente, por favor. Detalhe: "+error.message);

        }

      },(response) => {

        this.loader = false;
        let error   = this.api.formatError(response);
        this.app.info("Houve um erro. Tente nvamente, por favor. Detalhe: "+error.message);

      });
    

    }catch(e){

    }

  }
  /**
   * 
   * Set combo destinos
   * 
   */
  setComboDestinos(){

    let data = [];

    for (let index = 0; index < this.destinos.length; index++) {
      
      data.push({
        text: this.destinos[index].nome,
        value: this.destinos[index].id
      });
      
    }

    this.comboDestinos = data;

  }
  /**
   * 
   * Change city
   * 
   */
  _changeCity(data:any){

    this.dataItem.produto_cidade    = data.text;
    this.dataItem.produto_cidade_id = data.value;
    
  }
  /**
   * 
   * Init Data Item
   * 
   */
  initDataItem(){

    this.dataItem = {
      nome: "",
      produto_cidade_id: null,
      produto_cidade: ""
    }

  }
  /**
   * 
   * Close
   * 
   */
  _close(){

    this.produtos = [];

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    this.initDataItem();
    this.setComboDestinos();
  }

}
